import React, { useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { FaSpinner } from 'react-icons/fa';
import Select from 'react-select';
import { guestApi } from '../../api/guestList';
import { toast } from 'react-toastify';
import { useAuthContext } from '../../context/AuthContext';

const AddGuestModal = ({ show, onHide, groups, onGuestAdded }) => {
  const { isAuthenticated } = useAuthContext();

  const [submitting, setSubmitting] = useState(false);
  const [newGuest, setNewGuest] = useState({
    jina: '',
    selectedGroups: [],
    namba: '',
    pledge_amount: '',
    paid_amount: '',
    card_type: 'Single',
    email: ''
  });

  // Transform groups for dropdown
  let flatGroups = groups;
  if (Array.isArray(groups) && groups.length > 0 && Array.isArray(groups[0])) {
    flatGroups = groups.flat();
  }

  const groupOptions = flatGroups && flatGroups.length > 0 ? flatGroups.map(group => ({
    value: group.id || group.group_name || group.name,
    label: group.group_name || group.name
  })) : [];

  const formatPhoneNumber = (phone) => {
    if (!phone) return '';
    let phoneStr = String(phone).trim();
    phoneStr = phoneStr.replace(/[^\d+]/g, '');
    if (!phoneStr.startsWith('255') && !phoneStr.startsWith('0')) {
      phoneStr = '0' + phoneStr;
    }
    return phoneStr;
  };

  const handleAddGuest = async () => {
    if (!newGuest.jina || !newGuest.namba) {
      toast.warning('Please fill in name and phone number');
      return;
    }

    setSubmitting(true);
    try {
      const phoneNumber = formatPhoneNumber(newGuest.namba);

      const guestData = {
        name: String(newGuest.jina).trim(),
        phone_number: phoneNumber,
        email: newGuest.email || null,
        pledge: parseFloat(newGuest.pledge_amount) || 0,
        fund: parseFloat(newGuest.paid_amount) || 0,
        card_type: newGuest.card_type || 'Single',
        groups: newGuest.selectedGroups.map(g => g.value),
        group_ids: newGuest.selectedGroups.map(g => g.value),
        group_id: newGuest.selectedGroups.length > 0 ? newGuest.selectedGroups[0].value : null,
        guest_list_group_id: newGuest.selectedGroups.length > 0 ? newGuest.selectedGroups[0].value : null
      };

      const response = await guestApi.addGuest(guestData);

      if (response.success === false || response.status === 404) {
        toast.error(response.message || 'Failed to add guest');
        setSubmitting(false);
        return;
      }

      toast.success('Guest added successfully!');

      setNewGuest({
        jina: '',
        selectedGroups: [],
        namba: '',
        pledge_amount: '',
        paid_amount: '',
        card_type: 'Single',
        email: ''
      });

      onGuestAdded();
      onHide();

    } catch (err) {
      console.error('Error adding guest:', err);
      toast.error(err.response?.data?.message || err.message || 'Failed to add guest');
    } finally {
      setSubmitting(false);
    }
  };


  if (!isAuthenticated) return null;

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Ongeza Mgeni</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <div className="row">
            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label>Jina *</Form.Label>
                <Form.Control
                  type="text"
                  value={newGuest.jina}
                  onChange={(e) => setNewGuest({ ...newGuest, jina: e.target.value })}
                  required
                />
              </Form.Group>
            </div>
            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label>Kikundi (Makundi)</Form.Label>
                <Select
                  isMulti
                  options={groupOptions}
                  value={newGuest.selectedGroups}
                  onChange={(selected) => setNewGuest({ ...newGuest, selectedGroups: selected || [] })}
                  placeholder="-- Chagua Kikundi --"
                  className="react-select-container"
                  classNamePrefix="react-select"
                />
              </Form.Group>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label>Namba *</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="e.g., 0784859930"
                  value={newGuest.namba}
                  onChange={(e) => setNewGuest({ ...newGuest, namba: e.target.value })}
                  required
                />
              </Form.Group>
            </div>
            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  value={newGuest.email}
                  onChange={(e) => setNewGuest({ ...newGuest, email: e.target.value })}
                />
              </Form.Group>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4">
              <Form.Group className="mb-3">
                <Form.Label>Ahadi (TZS)</Form.Label>
                <Form.Control
                  type="number"
                  value={newGuest.pledge_amount}
                  onChange={(e) => setNewGuest({ ...newGuest, pledge_amount: e.target.value })}
                />
              </Form.Group>
            </div>
            <div className="col-md-4">
              <Form.Group className="mb-3">
                <Form.Label>Mchango (TZS)</Form.Label>
                <Form.Control
                  type="number"
                  value={newGuest.paid_amount}
                  onChange={(e) => setNewGuest({ ...newGuest, paid_amount: e.target.value })}
                />
              </Form.Group>
            </div>

          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Funga
        </Button>
        <Button variant="primary" onClick={handleAddGuest} disabled={submitting}>
          {submitting ? <FaSpinner className="fa-spin" /> : 'Hifadhi Mgeni'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddGuestModal;
